export const mapboxKey = "pk.eyJ1Ijoiam9lY3VzZGluIiwiYSI6IjFmMzMzODhmYTQ4ZWM4MmYwZGVlZDMwMTJmMDIyZWQwIn0.8taIUk7YHSD1srUfcacXBA";

export const OSKey = "IDNZQsBKE13RbhtGdVHc7snUSWFFFv3L";

export const mapboxSearchKey = "pk.eyJ1Ijoiam9lY3VzZGluIiwiYSI6ImNqYmNibGR1aTE0djkyeHBiNG03aWM2OHAifQ.xxvgx0NosHRcDtaOAE-CFQ";
